// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_j7-0";
export var discountCodeInput = "_j7-1";